// 精彩瞬间
export default [
  // 精彩瞬间列表
  {
    path: '/wonderfulList/index',
    name: 'wonderfulList',
    meta: {
      IndexHeader: true,
      itemIndex: 3
    },
    component: () =>
    import(/* webpackChunkName: "wonderfulMoment" */ '@/components/wonderfulMoment/index')
  },
  // 照片墙
  {
    path: '/wonderfulList/photoList',
    name: 'photoList',
    meta: {
      IndexHeader: true,
      itemIndex: 3
    },
    component: () =>
    import(/* webpackChunkName: "wonderfulMoment" */ '@/components/wonderfulMoment/photo-list')
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/wonderful-moment.js